export class CommonConstants {
    public static PHONE_REGEX = '/^(\s?[0-9]{2}\s?)([0-9]{3}\s?[0-9]{3}|[0-9]{2}\s?[0-9]{2}\s?[0-9]{2})$/';
    public static EMAIL_REGEX = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
    public static NUMBER_ALLOWED_REGEX = /^[0-9]*\.?[0-9]*$/;
    public static encryptSecretKey = "9b05f590eca53ffdbb2d16e3bcd1f015b06860420cded62768383f343c1a9445";

    public static TOKEN = '_AT';

    public static USER_DATA = '_UT';
    public static PER_PAGE = '_PP';
    public static CURRENT_PAGE = '_CP';
    public static PAGE_NAME = '_PN';
    public static LENGTH = '_L';
    public static SORT_KEY = '_SK';
    public static IS_SEARCH = '_IS';
    public static IS_BACK = '_IB';
    public static USER_STATUS = '_US';
    public static FORGOT_EMAIL = '_FE';
    public static VERIFY_EMAIL = '_VE';
    public static OTP_TIMER = '_OT';
    public static OTP_SENT = '_OS';
    public static QUERY = '_QR';
    public static OTP_VALUE = '_OV';
    public static DEVICE_TOKEN = '_DT';
    public static UID = '_UD';
    public static CURRENT_USER = '_CU';
    public static IS_ADMIN = '_IA';
    public static DEFAULT_ROUTE = '_DR';
    public static USER_ROLE = '_UR';
    public static PROJECT_ID = '_PI';

    public static REMEMBER_ME = '_RM';

}
